import React, {useEffect} from 'react';
import {ClipboardText, Palette} from '@phosphor-icons/react';
import {Tab} from '../../../../components';
import ObstructionProperties from './ObstructionProperties';
import ObstructionStyle from './ObstructionStyle';
import {useViewerStore} from "../../../../store/store";
import { TabItem } from '../../../../@types/types';

const Obstruction: React.FC = () => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);

    const items: TabItem[] = [
        {
            icon: (<ClipboardText size={24} weight='fill'/>),
            content: (<ObstructionProperties/>),
            title: 'Obstruction Properties',
            is_active: true,
        },
        {
            icon: (<Palette size={24} weight='fill'/>),
            content: (<ObstructionStyle/>),
            title: 'Obstruction Style',
            is_active: false,
        },
    ];

    useEffect(() => {
        if (sceneViewer) sceneViewer.setTabInfo('Obstruction Properties');
    }, []);

    return ( <Tab items={items}/> );
}

export default Obstruction;